import { Component, OnInit } from '@angular/core';
import { LibraryService } from 'src/app/services/Library/library.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';

@Component({
  selector: 'app-book-edition',
  templateUrl: './book-edition.component.html',
  styleUrls: ['./book-edition.component.css']
})

export class BookEditionComponent implements OnInit {


  Submitted:boolean=false;

  constructor(private  libraryservice: LibraryService,private lookupservice: LookupService, public globalHelper: GlobalHelper, 
    private spinnerService: Ng4LoadingSpinnerService) { }

  BookEdditionMSTModel =
    {
        BookEdditionID: 0,
        BookEddition: '',
        IsActive:true
    }

 BookEdditionMSTList = [];

 Clear () {
    this.BookEdditionMSTModel.BookEddition = '';
    this.BookEdditionMSTModel.BookEdditionID = 0;
    this.Submitted = false;
}

SaveEddition(valid) {
  this.Submitted = true;
  if(valid){
   this.spinnerService.show();
        this.libraryservice.SaveEddition(JSON.stringify(this.BookEdditionMSTModel)).subscribe((response: any) => {
            this.spinnerService.hide();
            this.globalHelper.CheckActionStatus(response);
            this.GetAllEddition();
            this.Clear();
        })
      }
    }



BookEditionMarkActive (obj) {
    this.Clear();
    this.BookEdditionMSTModel.BookEdditionID = obj.BookEdditionID;
    this.BookEdditionMSTModel.IsActive = obj.IsActive == true ? false : true;
    this.spinnerService.show();
    this.libraryservice.BookEditionMarkActive(JSON.stringify(this.BookEdditionMSTModel)).subscribe( (response:any) => {
       this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(response);
        this.GetAllEddition();
        this.Clear();
    })

}

GetAllEddition  () {
  this.spinnerService.show();
    this.libraryservice.GetAllEddition().subscribe( (response:any) => {
        this.BookEdditionMSTList = response.BookEdditionMSTList;
        this.spinnerService.hide();
    });

}
Edit  (obj) {
    this.BookEdditionMSTModel.BookEddition = obj.BookEddition;
    this.BookEdditionMSTModel.BookEdditionID = obj.BookEdditionID;

}

  ngOnInit() {
    this.GetAllEddition  () ;
  }

}